module.exports = __webpack_public_path__ + "static/media/home-get-a-wellbeing-pulse.ad6ba536.png";